export default __webpack_public_path__ + "static/treatmentarea-armsafter-2dcacc141effbfc146273eca4e59c849.webp";